import { jsx as _jsx } from "react/jsx-runtime";
import { getGrausEscolaridade } from '../../../api';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 650 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function GrausEscolaridade() {
    return (_jsx(GridBase, { pagina: PAGINAS.GRAUS_ESCOLARIDADE, paginaPermissao: FUNCIONALIDADES.GRAUS_ESCOLARIDADE, rota: ROUTES.GRAUS_ESCOLARIDADE, fetchData: function (str, _, pag) { return getGrausEscolaridade(str, pag); }, columns: COLUNAS }));
}
